import { Box } from '@mui/material';
import { uiConfig } from '../../config/uiConfig';

type Props = {
  firstName: string;
  lastName: string | null;
  size?: number;
};

// user profile pic when image is not available
// first letter of first and last name
// color: secondary.main
// improvement: use random color from theme
function LetterAvatar({ firstName, lastName, size }: Props) {
  const initials = `${firstName ? firstName[0].toUpperCase() : ''}${
    lastName ? lastName[0].toUpperCase() : ''
  }`;
  const randomIndex = Math.floor(Math.random() * uiConfig.avatarBackgroundColors.length);
  const randomBackgroundColor = uiConfig.avatarBackgroundColors[randomIndex];
  return (
    <Box
      sx={{
        borderRadius: '50%',
        backgroundColor: randomBackgroundColor,
        color: 'white',
        width: `${size}px`,
        height: `${size}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {initials}
    </Box>
  );
}

LetterAvatar.defaultProps = {
  size: 24,
};

export default LetterAvatar;
